import Form from './model/form'

var EmbeddedForm = Form.extend({


	url: function(options) {
		return 'api/forms/' + this.get('id') + '/shared/' + this.get('token')
	}

})

export default EmbeddedForm
EmbeddedForm.__filename__ = 'forms/embedded-form.js'
